export class Partner{
	id;
	slug;
	title;
	date;
	
	image;
	description;

	exhibitions;
	
	constructor (object)
	{
		// console.log("Partner", object)

		// Info
		this.id = object.id || null;
		this.slug = object.slug || null;
		this.title = object.title.rendered || null;
		this.date = object.date || null;

		// Content
		this.websiteUrl = object.meta_box.content.website_url || null;
		this.url = object.meta_box.content._get_file || null;
	}
}


// WEBPACK FOOTER //
// ./src/data/classes/partner.class.js